module.exports = __webpack_public_path__ + "static/img/gs5.795930e2.jpg";